/**
 * The Voltra mark, as path data.
 *
 * Its own module because a file that exports both components and constants
 * loses fast refresh — editing the logo would reload the whole app.
 *
 * Kept in lockstep with `public/logo-mark.svg` by `__tests__/Logo.test.tsx`.
 * That file is the one the favicon and the manifest point at; this one is what
 * React renders so the mark can take `currentColor`. Two copies of a shape
 * drift silently, so they are asserted equal.
 *
 * Measured off the brand PNG and verified at 98.7% pixel overlap with it.
 */
export const MARK_PATHS = {
  /** The main arc: 224 degrees, open at the top. */
  ring: 'M 7.9 33 A 45.4 45.4 0 1 0 92.1 33',
  /** The detached cap over the opening. */
  cap: 'M 67 7.9 A 45.4 45.4 0 0 0 33 7.9',
  /** The V. Butt caps, so each arm is cut square to its own angle. */
  v: 'M 20.5 23 L 50 73.2 L 79.5 23',
} as const;

export const MARK_STROKE_WIDTH = 9.4;
